export default __webpack_public_path__ + "static/notify3-922e08b6ed65d981e0b6e63e21378669.png";